<template>
  <div class="team-buy w-full">
    <a-alert
      v-if="isRightType16 && isChinese()"
      :message="`${rights?.rights_name}的加购言币总上限为${
        rights?.add_more_credit_coins_limit || 0
      }, 当前可加购${remainCoinsCount || 0}言币`"
      type="info"
      show-icon
      class="mb-[26px] mt-[-14px]"
    />
    <div
      :class="{
        global: isGlobalVersion(),
      }"
    >
      <div
        v-for="(item, idx) in packages"
        :key="item.id"
        :class="{
          active: item.id === picked?.id,
          disabled: getCounts(item) === 0,
        }"
        @click="handlePick(item)"
      >
        <div class="title">
          {{ item.title }}
          <a-divider type="vertical" />
          <span v-if="isChinese()" class="sub"> {{ $t('sheng-yu') }} {{ getCounts(item) }} </span>
        </div>
        <div class="card mt-[10px] px-[20px] py-[25px]">
          <iconpark-icon
            v-if="item.id === picked?.id"
            class="selected text-[24px]"
            name="xuanzhong"
          ></iconpark-icon>
          <div class="price text-error-6 font-bold">
            <span class="price-prefix text-[16px]">
              {{ formatPrice(item.price).prefix }}
            </span>
            <span class="price-num text-[28px]">
              {{ formatPrice(item.price).value }}
            </span>
          </div>
          <div class="coin-count">
            <span class="icon-value text-primary text-[14px]">
              {{ $t('gong-itemtotalcreditcoins-yan-bi', [item.total_credit_coins]) }}
              <br v-if="isGlobalVersion()" />
              {{
                $t('yu-ji-sheng-chan-getavailabletimecountitemtotalcreditcoins-shi-pin', [
                  getAvailableTimeCount(item.total_credit_coins),
                ])
              }}
              <Tooltip placement="right">
                <template #content>
                  {{
                    $t(
                      'gen-ju-quan-ping-tai-yong-hu-ping-jun-xiao-shuai-ji-suan-shi-ji-xiao-hao-yan-bi-shu-yi-ge-ren-zhi-zuo-xiao-shuai-wei-zhun',
                    )
                  }}
                </template>
                <iconpark-icon class="tip-icon" name="info"></iconpark-icon>
              </Tooltip>
            </span>
          </div>
        </div>
        <a-alert
          v-if="getCounts(item) === 0 && !isGlobalVersion()"
          class="alert mt-[6px]"
          type="warning"
          :message="$t('wu-fa-xuan-ze-gai-tao-can-yi-chao-chu-yan-bi-jia-gou-shu-liang-shang-xian')"
        ></a-alert>
        <a-divider v-if="!isGlobalVersion() && idx !== packages.length - 1" class="gap">
          or
        </a-divider>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Tooltip from '@rendora/design/components/tooltip/Tooltip.vue';
import { getOrderClientRemainedBuyCreditCoinsCount, type ICreditCoinsPackage } from '~/api';
import { USER_LEVEL_KEY, type IEquity } from '~/api/interface';
import { useTime } from '~/hooks/useTime';
import { formatPrice } from '~/utils/equity-helper';

const rights = inject<Ref<IEquity>>('rights');
const { $t } = useNuxtApp();

defineProps<{
  packages: ICreditCoinsPackage[];
  picked?: ICreditCoinsPackage;
}>();

const { formatDuration } = useTime();

const getAvailableTimeCount = (totalCreditCoins: number) => {
  return formatDuration(totalCreditCoins * 0.2 * 1000, d => {
    const s = d.seconds();
    const m = d.minutes();
    const h = d.hours();
    let str = '';
    if (s > 0) {
      str = $t('dseconds-miao', [d.seconds()]);
    }
    if (m > 0 || h > 0) {
      str = $t('dminutes-fen-zhong', [m + h * 60]) + str;
    }
    return str;
  });
};
// 是团队入门版
const isRightType16 = computed(() => {
  return rights?.value.rights_type === USER_LEVEL_KEY.TEAM_LIGHT;
});

const { data: remainCoins } = await useAsyncData(() => getOrderClientRemainedBuyCreditCoinsCount());

const remainCoinsCount = computed(() => {
  return remainCoins.value?.data?.remained_credit_coins;
});

const getCounts = (item: ICreditCoinsPackage) => {
  const remained_credit_coins = remainCoins.value?.data?.remained_credit_coins;

  if (remained_credit_coins === null) {
    return null;
  }

  return Math.floor((remained_credit_coins || 0) / item.total_credit_coins);
};

const emits = defineEmits(['change']);

const handlePick = (v: ICreditCoinsPackage) => emits('change', v);
</script>

<style lang="scss" scoped>
.tip-icon {
  transform: translateY(2px);
  color: var(--text-1);
}
.global {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr);
}
.selected {
  position: absolute;
  right: 10px;
  top: 10px;
}
.title {
  font-weight: 500;
  font-size: 14px;
}
.sub {
  color: var(--text-1-60);
  font-weight: 400;
}
.gap {
  font-size: 14px;
  color: var(--text-1-50);
}
.disabled {
  pointer-events: none;

  .card {
    opacity: 0.5;
  }
}
.alert {
  font-size: 12px;
  text-align: center;
  border: none;
}

.active {
  .card {
    border: 2px solid var(--purple-6);
    background: var(--purple-2);
  }
}
.card {
  position: relative;
  cursor: pointer;
  background-color: var(--back-3);
  border-radius: 8px;
  border: 2px solid transparent;
}
</style>
